module.exports = {"445321100":"新城镇","445321101":"车岗镇","445321103":"水台镇","445321104":"稔村镇","445321105":"东成镇","445321107":"太平镇","445321108":"里洞镇","445321110":"大江镇","445321112":"天堂镇","445321113":"河头镇","445321114":"簕竹镇","445321115":"六祖镇","445321501":"广东省西江林业局良洞迳林场","445321502":"云浮市国有水台林场","445321503":"国营新兴县岩头林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445321.json
// module id = 1892
// module chunks = 0